
import React from 'react';
import {Box, Grid, MenuItem, Select, TextField, Typography} from '@mui/material';

function FilterControls({ uniqueRegionNames, regionFilter, setRegionFilter, searchQuery, setSearchQuery, termFilter, setTermFilter }) {
  return (
   <Box sx={{ padding: 2, backgroundColor: '#f9f9f9', borderRadius: '8px' }}>

  <Grid container spacing={2} alignItems="center">
    <Grid item xs={12} sm={4}>
      <Typography variant="body1">
        Filter by Region:
      </Typography>
      <Select
        value={regionFilter}
        onChange={(e) => setRegionFilter(e.target.value)}
        variant="outlined"
        fullWidth
      >
        {Array.from(uniqueRegionNames).map((region) => (
          <MenuItem key={region} value={region}>
            {region}
          </MenuItem>
        ))}
      </Select>
    </Grid>
    <Grid item xs={12} sm={4}>
      <Typography variant="body1">
         Filter by Term:
        </Typography>
      <Select
          value={termFilter}
          onChange={(e) => setTermFilter(e.target.value)}
          variant="outlined"
          fullWidth
      >
        <MenuItem value="1 Year">1 Year</MenuItem>
        <MenuItem value="3 Years">3 Years</MenuItem>
      </Select>
    </Grid>
    <Grid item xs={12} sm={4}>
    <Typography variant="body1">
        Search by Instance Type:
    </Typography>
      <TextField
        type="text"
        placeholder="Search by Instance Type"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        variant="outlined"
        fullWidth
      />
    </Grid>

  </Grid>
</Box>

  );
}

export default FilterControls;
